// Nom lisible d'une consigne de modération, dérivé du triplet (product, object, agent_mode)
// servi par CD13 (entrées `by_version` / `by_version_global` de GET …/verdicts).
//
// ⛔ POURQUOI CE FICHIER EXISTE — ET POURQUOI IL DUPLIQUE Agents.jsx. L'écran Monitoring doit
// nommer une consigne avec les MÊMES mots que l'écran d'édition (décision E du ticket B6_02),
// mais il ne peut pas importer GROUPS/fallbackTitle depuis Agents.jsx : ce module importe
// PromptDiff + PromptEditor + les méthodes d'écriture du service (cycle Agents ↔ PromptDiff,
// signalé piégeux) — un écran de lecture n'a rien à faire dans ce cycle. Les deux tables
// ci-dessous sont donc une COPIE DÉLIBÉRÉE de Agents.jsx (GROUPS, REGIME_LABELS) : si un
// libellé change là-bas, le changer ici aussi.
//
// ⛔ JAMAIS le slug de l'agent_id interprété en nom lisible : il MENT (`untitled-agent` est
// l'agent stricte GC, `external-human-moderate` l'agent doute GC). L'id brut, présenté comme
// un identifiant, reste permis — c'est le repli du cas « agent hors des 6 descripteurs »,
// où product/object/agent_mode valent tous null (le contrôleur ne parse jamais le slug).

const GROUP_LABELS = {
  'GC|comment': 'GC',
  'GD|topic': 'GD sujets',
  'GD|message': 'GD messages'
};

// `agent_mode` de CD13 = le `regime` des descripteurs VERDICT_AGENTS (`strict` / `doubt`) —
// à ne confondre ni avec `applied_regime` (applied/suggested), ni avec le réglage de config.
const AGENT_MODE_LABELS = {
  strict: 'IA stricte (AI_ONLY)',
  doubt: 'IA + doute (REVIEW)'
};

// Rend le même libellé que fallbackTitle(Agents.jsx) pour une consigne connue
// (« GC — IA stricte (AI_ONLY) », « GD messages — IA + doute (REVIEW) »…), et l'agent_id
// brut sinon. Une valeur d'agent_mode inconnue reste visible telle quelle plutôt que de
// rendre deux consignes indistinguables (même exigence que D35).
export function consigneLabel(entry) {
  const e = entry || {};
  const group = GROUP_LABELS[`${e.product}|${e.object}`] || null;
  const mode = e.agent_mode
    ? (AGENT_MODE_LABELS[e.agent_mode] || `régime « ${e.agent_mode} »`)
    : null;
  if (group && mode) return `${group} — ${mode}`;
  if (group) return group;
  return e.agent_id ? `agent ${e.agent_id}` : 'consigne inconnue';
}
